
export class IntersectItem {

    private targetItems: THREE.Object3D[] = [];

    constructor() {}

    public setTargetItems(targetItems: THREE.Object3D[]): void {
        this.targetItems = targetItems;
    }

    public targetItem(raycaster: THREE.Raycaster): THREE.Object3D {
        const intersects = raycaster.intersectObjects(this.targetItems);
        if (intersects.length === 0) return null;

        if (intersects[0].object?.userData?.type) return intersects[0].object;

        return this.findAncestorByUserData(intersects[0].object);
    }

    /** Houseデータ以外 */
    public findAncestorByUserData(object: THREE.Object3D): THREE.Object3D {
        let currentObject = object;
        while (currentObject !== null) {
            if (currentObject.userData?.modelInfo) {
                return currentObject;
            }
            currentObject = currentObject.parent;
        }
        return null;
    }
}